module.exports = __webpack_public_path__ + "static/media/stands-out-mobile.8fc6762a.png";